import { getConfig } from '@cian/config/browser';
import { parseCookies } from '@cian/utils/lib/shared/cookie';
import { getTeaserApiUrl } from '../getTeaserApiUrl';

export interface ITeaserEventProps {
  realtyUserId?: number | string | null;
  bannerId?: string;
  section: string;
  action: 'click' | 'show';
}

export function sendAdsEvent(event: ITeaserEventProps) {
  const config = getConfig();

  const disableSendAdsEvents = !!config.get<boolean>('builders.disableSendAdsEvents');

  const cid = parseCookies(document.cookie)['_CIAN_GK'];
  const { action, bannerId, realtyUserId, section } = event;
  const teaserApiUrl = getTeaserApiUrl();
  const isSectionAvailable = ['daily-rent', 'rent', 'new-buildings', 'index', 'sale'].includes(section);

  if (!teaserApiUrl || !bannerId || disableSendAdsEvents || !isSectionAvailable) {
    return;
  }

  const userId = Number(realtyUserId);

  fetch(teaserApiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      user_id: isFinite(userId) ? userId : undefined,
      device_type: 'desktop',
      cid,
      pageType: 'Home',
      items: [
        {
          action,
          bannerId,
          bannerPlace: `home_${section}`,
          timestamp: Date.now(),
          dl: window.location.href,
        },
      ],
    }),
  });
}
